
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23","height":"19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M20.636 4.656c.014.204.014.408.014.613 0 6.231-4.743 13.411-13.411 13.411A13.32 13.32 0 010 16.564c.38.044.744.059 1.138.059a9.44 9.44 0 005.852-2.014 4.722 4.722 0 01-4.407-3.27c.292.044.584.073.89.073.424 0 .847-.058 1.24-.16A4.714 4.714 0 01.935 6.626v-.059c.627.35 1.357.57 2.13.599a4.71 4.71 0 01-2.1-3.926c0-.876.233-1.678.641-2.379a13.398 13.398 0 009.72 4.933 5.319 5.319 0 01-.117-1.08A4.712 4.712 0 0115.922 0c1.357 0 2.583.57 3.444 1.489A9.28 9.28 0 0022.358.35a4.7 4.7 0 01-2.072 2.598A9.458 9.458 0 0023 2.218a10.134 10.134 0 01-2.364 2.438"}})])
          )
        }
      }
    